import Contract from './Contract';

export function isTierApplicable (contract) {
    return !!(contract && contract.type && contract.type.id === Contract.enums.types.lim);
}

export function shouldDisplayTierChip (contract) {
    return isTierApplicable(contract) && !!(contract && contract.tier);
}

const TIER_STYLES = {
    1: { color: '#CD7F32', textColor: 'white' }, // Basic – Bronze
    2: { color: '#C0C0C0', textColor: 'black' }, // Plus  – Silber
    3: { color: '#D4AF37', textColor: 'black' }, // Max   – Gold
};

const TIER_STYLE_FALLBACK = { color: 'grey', textColor: 'white' };

export function tierColor (contract) {
    if (!shouldDisplayTierChip(contract)) {
        return null;
    }

    return (TIER_STYLES[contract.tier.id] || TIER_STYLE_FALLBACK).color;
}

export function tierTextColor (contract) {
    if (!shouldDisplayTierChip(contract)) {
        return null;
    }

    return (TIER_STYLES[contract.tier.id] || TIER_STYLE_FALLBACK).textColor;
}
